import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="quote-status-update"
export default class extends Controller {
  connect() {
    console.log("quoteStatusUpdateController connected");
  }

  async update(event) {
    const id = event.target.closest("tr").dataset.quoteId;
    const status = event.target.value;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const response = await fetch(`/quotes/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ quote: { status: status } })
    });

    if (response.ok) {
      const alert = document.createElement("div");
      alert.className = "alert alert-success alert-position text-center";
      alert.innerHTML = `成功しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    }
  }
}
